import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Select } from '@99designs/common/components/Select';

export default class ContestSelect extends React.Component {
    render() {
        const options = this.props.contests.map(contest => ({
            label: contest.title,
            value: contest.id.toString(),
        }));
        return (
            <div className="field">
                <div className="field__input">
                    <h2 className="field__title">
                        <FormattedMessage id="contest" />
                    </h2>
                    <Select
                        onChange={value => {
                            this.props.handleChange(value);
                        }}
                        value={this.props.selectedContestId}
                        variations={['default']}
                        name="contestSelect"
                        options={options}
                    />
                </div>
            </div>
        );
    }
}

ContestSelect.propTypes = {
    contests: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            id: PropTypes.number.isRequired,
        })
    ).isRequired,
    selectedContestId: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/js/apps/invite-designer/components/ContestSelect.jsx